/*global analyticEventTracker */

var freeExtras = {
    init: function(maxShow) {
        var freeExtra = $('.free-extras'),
            freeExtraList = $('.free-extras li'),
            freeExtraCount = freeExtraList.length,
            more = freeExtra.data('more-text'),
            less = freeExtra.data('less-text'),
            max = maxShow || 5,
            moreText = more.replace('%s', freeExtraCount - max),
            lessText = less.replace('%s', freeExtraCount - max);

        if (freeExtraCount > max + 1 && !freeExtra.hasClass('show-all')) {
            freeExtraList.each(function(i) {
                if (i > max - 1) {
                    $(this).addClass('hide');
                }
            });

            freeExtra
                .append('<li class="more-less"><a href="" data-more-text="' + moreText + '" data-less-text="' + lessText + '">' + moreText + '</a></li>');

            freeExtras.action();
        }
    },
    action: function() {
        $(document).on('click', '.more-less a', function(e) {
            e.preventDefault();

            var $this = $(this),
                more = $this.data('more-text'),
                less = $this.data('less-text');

            const moreOrLess = $this.hasClass('less') ? 'Less' : 'More';
            const eventName = `My_Booking_Car_Info_Show_${moreOrLess}`;

            $this.text(($this.hasClass('less') ? more : less))
                .toggleClass('less')
                .parents('.free-extras')
                .find('.hide')
                .toggleClass('show');

            analyticEventTracker.sendInstantEvent(eventName, $this.data());
        });
    }
};
